import { FC } from 'react';
import DriverLicense from 'src/front/components/identity/form/DriverLicense';
import ForeignPassport from 'src/front/components/identity/form/ForeignPassport';
import Inn from 'src/front/components/identity/form/Inn';
import InsuranceCertificate from 'src/front/components/identity/form/InsuranceCertificate';
import MigrationCard from 'src/front/components/identity/form/MigrationCard';
import PassportForeignCitizen from 'src/front/components/identity/form/PassportForeignCitizen';
import PassportRf from 'src/front/components/identity/form/PassportRf';
import ResidentPermit from 'src/front/components/identity/form/ResidentPermit';
import SeamanPassport from 'src/front/components/identity/form/SeamanPassport';
import TemporaryResidencePermit from 'src/front/components/identity/form/TemporaryResidencePermit';
import Visa from 'src/front/components/identity/form/Visa';
import { FormProps } from 'src/front/components/identity/FormProps';
import DefaultSchema, {
  DriverLicenseSchema,
  ForeignPassportSchema,
  InnSchema,
  InsuranceCertificateSchema,
  MigrationCardSchema,
  PassportForeignCitizenSchema,
  PassportRfSchema,
  ResidentPermitSchema,
  SeamanPassportSchema,
  TemporaryResidencePermitSchema,
  VisaSchema,
} from 'src/front/components/identity/ValidationShemas';
import * as Yup from 'yup';

export const IDENTITY_SCHEMA_MAP: Record<string, Yup.ObjectSchema> = {
  PS: PassportRfSchema,
  DL: DriverLicenseSchema,
  IC: InsuranceCertificateSchema,
  CT: InnSchema,
  RP: ResidentPermitSchema,
  VS: VisaSchema,
  MR: MigrationCardSchema,
  FP: ForeignPassportSchema,
  RR: TemporaryResidencePermitSchema,
  SP: SeamanPassportSchema,
  PT: PassportForeignCitizenSchema,
  default: DefaultSchema,
};

const IDENTITY_COMPONENT_MAP: Record<string, FC<FormProps>> = {
  PS: PassportRf,
  DL: DriverLicense,
  IC: InsuranceCertificate,
  CT: Inn,
  RP: ResidentPermit,
  VS: Visa,
  MR: MigrationCard,
  FP: ForeignPassport,
  RR: TemporaryResidencePermit,
  SP: SeamanPassport,
  PT: PassportForeignCitizen,
};

export default IDENTITY_COMPONENT_MAP;
